export default "__VITE_ASSET__mBRdMZz9__"